module.exports = __webpack_public_path__ + "static/media/instructivova4.43b95704.png";